module.exports = __webpack_public_path__ + "img/lunbo1.7ec7ac36.png";